/**
 *    @author:
 *    @since:
 *
 */

import { Component, OnInit, ViewEncapsulation} from '@angular/core';
import { Router } from '@angular/router'; 
import { TimerService } from 'src/refresh/service/timer-service';
import { FormBaseComponent } from '../_common/component/form-base.component';
import { InputData } from '../_common/data/input-data';
import { GAData, Path} from  "../_common/constant/page-const";
import { ESRAreYouSureValidation } from './ESR_are_you_sure.validator';

@Component({ 
      selector: 'ESR_are_you_sure',
      templateUrl: './ESR_are_you_sure.component.html',
      styleUrls: ['./ESR_are_you_sure.component.less'],
      //encapsulation: ViewEncapsulation.None
})
export class ESRAreYouSureComponent extends FormBaseComponent implements OnInit {

       // declare Field variable here

       constructor( protected router: Router ,
                    public timerService:TimerService,
                    public data:InputData ) {

                    super(router,timerService,null);  
                    super.setNextPage(Path.OrderSummary,Path.ESRMain);
                    super.setValidator(new ESRAreYouSureValidation(this));
                    //this.clear();
       }

       public ngOnInit() {
       }

       public onPreviousClick() {
            super.gtag(GAData.Link,GAData.back_areYouSure);
            super.onPreviousClick();
       }

       public onNextClick() : boolean {
            this.clear();
            window.history.back();
            super.gtag(GAData.Button,GAData.continue_product);   
            return true;
       }
     


       public clear() {

            let ESR = this.data.CESP;
            ESR.contactParent = -1;
            ESR.promoter = "";
            ESR.chk_consent = false;
     
            ESR.postalCode = "";
            ESR.country = "";
     
            ESR.contactLang = undefined;
     
            ESR.contactMethod = undefined ;
            ESR.contactEmail = '';
     
            ESR.firstArea = '';        
            ESR.firstNumber1 = '';        
            ESR.firstNumber2 = ''; 
            ESR.firstExt = '';       
            ESR.firstTTY = undefined;        
     
            ESR.secondArea = '';        
            ESR.secondNumber1 = '';        
            ESR.secondNumber2 = '';
            ESR.secondExt = '';    
            ESR.secondTTY = undefined;            
     
            ESR.contactTime = undefined; 
            ESR.emailForReceipt = '';
     
            //-----------------------------------------------------------
            ESR.category = 'X';
            ESR.chk_disclaimer = false;
            ESR.chk_privacy = false;
            ESR.chk_disclosure = false;
     }

}
